import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { FormControlLabel, Checkbox, darken } from '@mui/material';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledFormControlLabel = /*#__PURE__*/_styled(FormControlLabel, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1p80nft3"
})(_ref => {
  return {
    marginRight: 0,
    marginLeft: 0,
    alignItems: 'center',
    '& .MuiTypography-root': {
      lineHeight: 1.25
    }
  };
}, "");
const StyledCheckbox = /*#__PURE__*/_styled(Checkbox, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1p80nft2"
})(_ref2 => {
  let {
    theme,
    checkboxSize,
    color,
    mr,
    label,
    customColor
  } = _ref2;
  return _objectSpread2({
    padding: 0,
    marginRight: "".concat(mr, "px"),
    color: customColor || theme.customColors.purple[500],
    '& .MuiSvgIcon-root': {
      fontSize: "".concat(checkboxSize, "px")
    },
    '&.Mui-checked': {
      color: customColor || theme.customColors.purple[500]
    }
  }, label && {
    marginTop: '1px'
  });
}, "");
const StyledIcon = /*#__PURE__*/_styled('span', {
  shouldForwardProp: isStyledPropsValid,
  target: "e1p80nft1"
})(_ref3 => {
  let {
    theme,
    checkboxSize,
    color,
    boxBorderColor,
    boxBackgroundColor
  } = _ref3;
  const borderColor = boxBorderColor || theme.customColors.grey[500];
  const isTransparent = borderColor === 'transparent';
  return {
    position: 'relative',
    borderRadius: 4,
    width: checkboxSize,
    height: checkboxSize,
    background: boxBackgroundColor,
    border: "1px solid ".concat(borderColor),
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2
    },
    'input:not(:disabled):hover ~ &': {
      border: "1px solid ".concat(isTransparent ? borderColor : darken(borderColor, 0.2))
    },
    'input:disabled ~ &': {
      background: theme.customColors.grey[300],
      border: "1px solid ".concat(theme.customColors.grey[500])
    }
  };
}, "");
const getSVG = color => "url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71001C20.6801 7.32001 20.6801 6.69001 20.2901 6.30001C19.9001 5.91001 19.2701 5.91001 18.8801 6.30001L9.00014 16.17Z\" fill=\"".concat(encodeURIComponent(color), "\"/></svg>')");
const StyledCheckedIcon = /*#__PURE__*/_styled(StyledIcon, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1p80nft0"
})(_ref4 => {
  let {
    theme,
    color,
    checkboxSize,
    customColor,
    boxBorderColor,
    boxBackgroundColor
  } = _ref4;
  const baseColor = boxBackgroundColor || theme.customColors.purple[500];
  const borderColor = boxBorderColor || baseColor;
  const isTransparent = baseColor === 'transparent';
  return {
    overflow: 'hidden',
    backgroundColor: baseColor,
    border: "1px solid ".concat(borderColor),
    '&:before': {
      display: 'block',
      width: checkboxSize,
      height: checkboxSize,
      backgroundImage: getSVG(customColor || 'white'),
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      content: '""'
    },
    'input:not(:disabled):hover ~ &': {
      backgroundColor: isTransparent ? baseColor : darken(baseColor, 0.2),
      border: isTransparent ? borderColor : "1px solid ".concat(darken(borderColor, 0.2))
    },
    'input:disabled ~ &': {
      background: theme.customColors.grey[300],
      border: "1px solid ".concat(theme.customColors.grey[500]),
      '&:before': {
        backgroundImage: 'unset'
      }
    }
  };
}, "");
export { StyledCheckbox, StyledCheckedIcon, StyledFormControlLabel, StyledIcon };